import { motion, AnimatePresence } from "framer-motion";

export const Loader = ({ progress, done }) => {
  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="loading-gate"
          className="fixed inset-0 z-[10000] flex flex-col items-center justify-center bg-ink"
          exit={{ opacity: 0, filter: "blur(20px)" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="orb bg-electric" style={{ width: 380, height: 380, top: "20%", left: "30%" }} />
          <div className="orb bg-magenta" style={{ width: 320, height: 320, bottom: "18%", right: "28%" }} />

          <div className="relative flex flex-col items-center">
            <svg width="180" height="180" viewBox="0 0 180 180" className="rotate-[-90deg]">
              <circle cx="90" cy="90" r="82" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
              <motion.circle
                cx="90" cy="90" r="82" fill="none" stroke="url(#lg)" strokeWidth="2.5" strokeLinecap="round"
                strokeDasharray={2 * Math.PI * 82}
                strokeDashoffset={2 * Math.PI * 82 * (1 - progress / 100)}
                transition={{ ease: "linear" }}
              />
              <defs>
                <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" style={{ stopColor: "rgb(var(--electric))" }} />
                  <stop offset="100%" style={{ stopColor: "rgb(var(--magenta))" }} />
                </linearGradient>
              </defs>
            </svg>
            <div className="absolute inset-0 flex items-center justify-center rotate-0">
              <span className="font-display text-5xl font-bold tabular-nums" data-testid="loading-percent">
                {Math.round(progress)}
              </span>
            </div>
          </div>

          <div className="mt-10 overflow-hidden">
            <motion.p
              initial={{ y: "100%" }} animate={{ y: 0 }}
              transition={{ delay: 0.3, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="font-mono text-[0.7rem] uppercase tracking-[0.4em] text-white/40"
            >
              Curating the exhibition
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
